export const Webview = [
  {
    path: '/webview/:app_module_id',
    name: 'webview.index',
    component: () => import('@/pages/Webview/WebviewModule')
  },
]
